import { useSettings } from '@capsicum/common';
import { useDeleteAccount } from '@capsicum/socios-core';

export const useDeleteAccountScreen = () => {
	const { settings } = useSettings();
	const { deleteAccount } = useDeleteAccount();
	const supportLink = settings?.contactUsHereLink ?? 'https://mobile-app-content.socios.com/en_gb/contact-us';

	return {
		deleteAccount,
		privacyLink: settings?.privacyPolicyLink ?? '',
		supportLink
	};
};
